import { render, staticRenderFns } from "./tiposdelocais.vue?vue&type=template&id=55d281cc"
import script from "./tiposdelocais.vue?vue&type=script&lang=js"
export * from "./tiposdelocais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports